import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.bind";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import e from "styled-components";
import { spacing as r, mergeSpacings as n } from "@bedrock-layout/spacing-constants";

function t(e, r) {
  return e(r = {
    exports: {}
  }, r.exports), r.exports;
}

var o = "function" == typeof Symbol && Symbol["for"],
    a = o ? Symbol["for"]("react.element") : 60103,
    i = o ? Symbol["for"]("react.portal") : 60106,
    c = o ? Symbol["for"]("react.fragment") : 60107,
    u = o ? Symbol["for"]("react.strict_mode") : 60108,
    f = o ? Symbol["for"]("react.profiler") : 60114,
    s = o ? Symbol["for"]("react.provider") : 60109,
    l = o ? Symbol["for"]("react.context") : 60110,
    p = o ? Symbol["for"]("react.async_mode") : 60111,
    y = o ? Symbol["for"]("react.concurrent_mode") : 60111,
    d = o ? Symbol["for"]("react.forward_ref") : 60112,
    m = o ? Symbol["for"]("react.suspense") : 60113,
    b = o ? Symbol["for"]("react.suspense_list") : 60120,
    v = o ? Symbol["for"]("react.memo") : 60115,
    g = o ? Symbol["for"]("react.lazy") : 60116,
    h = o ? Symbol["for"]("react.block") : 60121,
    S = o ? Symbol["for"]("react.fundamental") : 60117,
    O = o ? Symbol["for"]("react.responder") : 60118,
    E = o ? Symbol["for"]("react.scope") : 60119;

function w(e) {
  if ("object" == typeof e && null !== e) {
    var r = e.$$typeof;

    switch (r) {
      case a:
        switch (e = e.type) {
          case p:
          case y:
          case c:
          case f:
          case u:
          case m:
            return e;

          default:
            switch (e = e && e.$$typeof) {
              case l:
              case d:
              case g:
              case v:
              case s:
                return e;

              default:
                return r;
            }

        }

      case i:
        return r;
    }
  }
}

function j(e) {
  return w(e) === y;
}

var $ = {
  AsyncMode: p,
  ConcurrentMode: y,
  ContextConsumer: l,
  ContextProvider: s,
  Element: a,
  ForwardRef: d,
  Fragment: c,
  Lazy: g,
  Memo: v,
  Portal: i,
  Profiler: f,
  StrictMode: u,
  Suspense: m,
  isAsyncMode: function isAsyncMode(e) {
    return j(e) || w(e) === p;
  },
  isConcurrentMode: j,
  isContextConsumer: function isContextConsumer(e) {
    return w(e) === l;
  },
  isContextProvider: function isContextProvider(e) {
    return w(e) === s;
  },
  isElement: function isElement(e) {
    return "object" == typeof e && null !== e && e.$$typeof === a;
  },
  isForwardRef: function isForwardRef(e) {
    return w(e) === d;
  },
  isFragment: function isFragment(e) {
    return w(e) === c;
  },
  isLazy: function isLazy(e) {
    return w(e) === g;
  },
  isMemo: function isMemo(e) {
    return w(e) === v;
  },
  isPortal: function isPortal(e) {
    return w(e) === i;
  },
  isProfiler: function isProfiler(e) {
    return w(e) === f;
  },
  isStrictMode: function isStrictMode(e) {
    return w(e) === u;
  },
  isSuspense: function isSuspense(e) {
    return w(e) === m;
  },
  isValidElementType: function isValidElementType(e) {
    return "string" == typeof e || "function" == typeof e || e === c || e === y || e === f || e === u || e === m || e === b || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === v || e.$$typeof === s || e.$$typeof === l || e.$$typeof === d || e.$$typeof === S || e.$$typeof === O || e.$$typeof === E || e.$$typeof === h);
  },
  typeOf: w
},
    x = t(function (e, r) {
  "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol["for"],
        n = e ? Symbol["for"]("react.element") : 60103,
        t = e ? Symbol["for"]("react.portal") : 60106,
        o = e ? Symbol["for"]("react.fragment") : 60107,
        a = e ? Symbol["for"]("react.strict_mode") : 60108,
        i = e ? Symbol["for"]("react.profiler") : 60114,
        c = e ? Symbol["for"]("react.provider") : 60109,
        u = e ? Symbol["for"]("react.context") : 60110,
        f = e ? Symbol["for"]("react.async_mode") : 60111,
        s = e ? Symbol["for"]("react.concurrent_mode") : 60111,
        l = e ? Symbol["for"]("react.forward_ref") : 60112,
        p = e ? Symbol["for"]("react.suspense") : 60113,
        y = e ? Symbol["for"]("react.suspense_list") : 60120,
        d = e ? Symbol["for"]("react.memo") : 60115,
        m = e ? Symbol["for"]("react.lazy") : 60116,
        b = e ? Symbol["for"]("react.block") : 60121,
        v = e ? Symbol["for"]("react.fundamental") : 60117,
        g = e ? Symbol["for"]("react.responder") : 60118,
        h = e ? Symbol["for"]("react.scope") : 60119;

    function S(e) {
      if ("object" == typeof e && null !== e) {
        var r = e.$$typeof;

        switch (r) {
          case n:
            var y = e.type;

            switch (y) {
              case f:
              case s:
              case o:
              case i:
              case a:
              case p:
                return y;

              default:
                var b = y && y.$$typeof;

                switch (b) {
                  case u:
                  case l:
                  case m:
                  case d:
                  case c:
                    return b;

                  default:
                    return r;
                }

            }

          case t:
            return r;
        }
      }
    }

    var O = s,
        E = u,
        w = c,
        j = n,
        $ = l,
        x = o,
        k = m,
        P = d,
        T = t,
        _ = i,
        N = a,
        C = p,
        I = !1;

    function A(e) {
      return S(e) === s;
    }

    r.AsyncMode = f, r.ConcurrentMode = O, r.ContextConsumer = E, r.ContextProvider = w, r.Element = j, r.ForwardRef = $, r.Fragment = x, r.Lazy = k, r.Memo = P, r.Portal = T, r.Profiler = _, r.StrictMode = N, r.Suspense = C, r.isAsyncMode = function (e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(e) || S(e) === f;
    }, r.isConcurrentMode = A, r.isContextConsumer = function (e) {
      return S(e) === u;
    }, r.isContextProvider = function (e) {
      return S(e) === c;
    }, r.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, r.isForwardRef = function (e) {
      return S(e) === l;
    }, r.isFragment = function (e) {
      return S(e) === o;
    }, r.isLazy = function (e) {
      return S(e) === m;
    }, r.isMemo = function (e) {
      return S(e) === d;
    }, r.isPortal = function (e) {
      return S(e) === t;
    }, r.isProfiler = function (e) {
      return S(e) === i;
    }, r.isStrictMode = function (e) {
      return S(e) === a;
    }, r.isSuspense = function (e) {
      return S(e) === p;
    }, r.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === s || e === i || e === a || e === p || e === y || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === d || e.$$typeof === c || e.$$typeof === u || e.$$typeof === l || e.$$typeof === v || e.$$typeof === g || e.$$typeof === h || e.$$typeof === b);
    }, r.typeOf = S;
  }();
}),
    k = t(function (e) {
  e.exports = "production" === process.env.NODE_ENV ? $ : x;
}),
    P = Object.getOwnPropertySymbols,
    T = Object.prototype.hasOwnProperty,
    _ = Object.prototype.propertyIsEnumerable,
    N = function () {
  try {
    if (!Object.assign) return !1;
    var e = new String("abc");
    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

    for (var r = {}, n = 0; n < 10; n++) {
      r["_" + String.fromCharCode(n)] = n;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(r).map(function (e) {
      return r[e];
    }).join("")) return !1;
    var t = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (e) {
      t[e] = e;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, t)).join("");
  } catch (e) {
    return !1;
  }
}() ? Object.assign : function (e, r) {
  for (var n, t, o = arguments, a = function (e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }(e), i = 1; i < arguments.length; i++) {
    for (var c in n = Object(o[i])) {
      T.call(n, c) && (a[c] = n[c]);
    }

    if (P) {
      t = P(n);

      for (var u = 0; u < t.length; u++) {
        _.call(n, t[u]) && (a[t[u]] = n[t[u]]);
      }
    }
  }

  return a;
},
    C = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    I = function I() {};

if ("production" !== process.env.NODE_ENV) {
  var A = C,
      R = {},
      M = Function.call.bind(Object.prototype.hasOwnProperty);

  I = function I(e) {
    var r = "Warning: " + e;
    "undefined" != typeof console && console.error(r);

    try {
      throw new Error(r);
    } catch (e) {}
  };
}

function V(e, r, n, t, o) {
  if ("production" !== process.env.NODE_ENV) for (var a in e) {
    if (M(e, a)) {
      var i;

      try {
        if ("function" != typeof e[a]) {
          var c = Error((t || "React class") + ": " + n + " type `" + a + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[a] + "`.");
          throw c.name = "Invariant Violation", c;
        }

        i = e[a](r, a, t, n, null, A);
      } catch (e) {
        i = e;
      }

      if (!i || i instanceof Error || I((t || "React class") + ": type specification of " + n + " `" + a + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof i + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), i instanceof Error && !(i.message in R)) {
        R[i.message] = !0;
        var u = o ? o() : "";
        I("Failed " + n + " type: " + i.message + (null != u ? u : ""));
      }
    }
  }
}

V.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (R = {});
};

var D = V,
    F = Function.call.bind(Object.prototype.hasOwnProperty),
    z = function z() {};

function W() {
  return null;
}

function q() {}

function L() {}

"production" !== process.env.NODE_ENV && (z = function z(e) {
  var r = "Warning: " + e;
  "undefined" != typeof console && console.error(r);

  try {
    throw new Error(r);
  } catch (e) {}
}), L.resetWarningCache = q;
var U = t(function (e) {
  e.exports = "production" !== process.env.NODE_ENV ? function (e, r) {
    var n = "function" == typeof Symbol && Symbol.iterator,
        t = "@@iterator",
        o = "<<anonymous>>",
        a = {
      array: u("array"),
      bool: u("boolean"),
      func: u("function"),
      number: u("number"),
      object: u("object"),
      string: u("string"),
      symbol: u("symbol"),
      any: c(W),
      arrayOf: function arrayOf(e) {
        return c(function (r, n, t, o, a) {
          if ("function" != typeof e) return new i("Property `" + a + "` of component `" + t + "` has invalid PropType notation inside arrayOf.");
          var c = r[n];
          if (!Array.isArray(c)) return new i("Invalid " + o + " `" + a + "` of type `" + s(c) + "` supplied to `" + t + "`, expected an array.");

          for (var u = 0; u < c.length; u++) {
            var f = e(c, u, t, o, a + "[" + u + "]", C);
            if (f instanceof Error) return f;
          }

          return null;
        });
      },
      element: c(function (r, n, t, o, a) {
        var c = r[n];
        return e(c) ? null : new i("Invalid " + o + " `" + a + "` of type `" + s(c) + "` supplied to `" + t + "`, expected a single ReactElement.");
      }),
      elementType: c(function (e, r, n, t, o) {
        var a = e[r];
        return k.isValidElementType(a) ? null : new i("Invalid " + t + " `" + o + "` of type `" + s(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
      }),
      instanceOf: function instanceOf(e) {
        return c(function (r, n, t, a, c) {
          var u;
          return r[n] instanceof e ? null : new i("Invalid " + a + " `" + c + "` of type `" + ((u = r[n]).constructor && u.constructor.name ? u.constructor.name : o) + "` supplied to `" + t + "`, expected instance of `" + (e.name || o) + "`.");
        });
      },
      node: c(function (e, r, n, t, o) {
        return f(e[r]) ? null : new i("Invalid " + t + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
      }),
      objectOf: function objectOf(e) {
        return c(function (r, n, t, o, a) {
          if ("function" != typeof e) return new i("Property `" + a + "` of component `" + t + "` has invalid PropType notation inside objectOf.");
          var c = r[n],
              u = s(c);
          if ("object" !== u) return new i("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + t + "`, expected an object.");

          for (var f in c) {
            if (F(c, f)) {
              var l = e(c, f, t, o, a + "." + f, C);
              if (l instanceof Error) return l;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(e) {
        return Array.isArray(e) ? c(function (r, n, t, o, a) {
          for (var c = r[n], u = 0; u < e.length; u++) {
            if ((f = c) === (s = e[u]) ? 0 !== f || 1 / f == 1 / s : f != f && s != s) return null;
          }

          var f,
              s,
              p = JSON.stringify(e, function (e, r) {
            return "symbol" === l(r) ? String(r) : r;
          });
          return new i("Invalid " + o + " `" + a + "` of value `" + String(c) + "` supplied to `" + t + "`, expected one of " + p + ".");
        }) : ("production" !== process.env.NODE_ENV && z(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), W);
      },
      oneOfType: function oneOfType(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && z("Invalid argument supplied to oneOfType, expected an instance of array."), W;

        for (var r = 0; r < e.length; r++) {
          var n = e[r];
          if ("function" != typeof n) return z("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + p(n) + " at index " + r + "."), W;
        }

        return c(function (r, n, t, o, a) {
          for (var c = 0; c < e.length; c++) {
            if (null == (0, e[c])(r, n, t, o, a, C)) return null;
          }

          return new i("Invalid " + o + " `" + a + "` supplied to `" + t + "`.");
        });
      },
      shape: function shape(e) {
        return c(function (r, n, t, o, a) {
          var c = r[n],
              u = s(c);
          if ("object" !== u) return new i("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + t + "`, expected `object`.");

          for (var f in e) {
            var l = e[f];

            if (l) {
              var p = l(c, f, t, o, a + "." + f, C);
              if (p) return p;
            }
          }

          return null;
        });
      },
      exact: function exact(e) {
        return c(function (r, n, t, o, a) {
          var c = r[n],
              u = s(c);
          if ("object" !== u) return new i("Invalid " + o + " `" + a + "` of type `" + u + "` supplied to `" + t + "`, expected `object`.");
          var f = N({}, r[n], e);

          for (var l in f) {
            var p = e[l];
            if (!p) return new i("Invalid " + o + " `" + a + "` key `" + l + "` supplied to `" + t + "`.\nBad object: " + JSON.stringify(r[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var y = p(c, l, t, o, a + "." + l, C);
            if (y) return y;
          }

          return null;
        });
      }
    };

    function i(e) {
      this.message = e, this.stack = "";
    }

    function c(e) {
      if ("production" !== process.env.NODE_ENV) var n = {},
          t = 0;

      function a(a, c, u, f, s, l, p) {
        if (f = f || o, l = l || u, p !== C) {
          if (r) {
            var y = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw y.name = "Invariant Violation", y;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var d = f + ":" + u;
            !n[d] && t < 3 && (z("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + f + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[d] = !0, t++);
          }
        }

        return null == c[u] ? a ? new i(null === c[u] ? "The " + s + " `" + l + "` is marked as required in `" + f + "`, but its value is `null`." : "The " + s + " `" + l + "` is marked as required in `" + f + "`, but its value is `undefined`.") : null : e(c, u, f, s, l);
      }

      var c = a.bind(null, !1);
      return c.isRequired = a.bind(null, !0), c;
    }

    function u(e) {
      return c(function (r, n, t, o, a, c) {
        var u = r[n];
        return s(u) !== e ? new i("Invalid " + o + " `" + a + "` of type `" + l(u) + "` supplied to `" + t + "`, expected `" + e + "`.") : null;
      });
    }

    function f(r) {
      switch (typeof r) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !r;

        case "object":
          if (Array.isArray(r)) return r.every(f);
          if (null === r || e(r)) return !0;

          var o = function (e) {
            var o = r && (n && r[n] || r[t]);
            if ("function" == typeof o) return o;
          }();

          if (!o) return !1;
          var a,
              i = o.call(r);

          if (o !== r.entries) {
            for (; !(a = i.next()).done;) {
              if (!f(a.value)) return !1;
            }
          } else for (; !(a = i.next()).done;) {
            var c = a.value;
            if (c && !f(c[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function s(e) {
      var r = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, r) {
        return "symbol" === e || !!r && ("Symbol" === r["@@toStringTag"] || "function" == typeof Symbol && r instanceof Symbol);
      }(r, e) ? "symbol" : r;
    }

    function l(e) {
      if (null == e) return "" + e;
      var r = s(e);

      if ("object" === r) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }

      return r;
    }

    function p(e) {
      var r = l(e);

      switch (r) {
        case "array":
        case "object":
          return "an " + r;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + r;

        default:
          return r;
      }
    }

    return i.prototype = Error.prototype, a.checkPropTypes = D, a.resetWarningCache = D.resetWarningCache, a.PropTypes = a, a;
  }(k.isElement, !0) : function () {
    function e(e, r, n, t, o, a) {
      if (a !== C) {
        var i = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw i.name = "Invariant Violation", i;
      }
    }

    function r() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: r,
      element: e,
      elementType: e,
      instanceOf: r,
      node: e,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: L,
      resetWarningCache: q
    };
    return n.PropTypes = n, n;
  }();
}),
    Y = Object.freeze(["\n  box-sizing: border-box;\n  ", "\n"]),
    B = new Set(["left", "right", "top", "bottom", "inlineStart", "inlineEnd", "blockStart", "blockEnd"]),
    J = new Set(Object.keys(r)),
    H = e.div(Y, function (e) {
  return (void 0 === (r = e.theme.spacing) && (r = {}), function (e) {
    if (void 0 === e && (e = "lg"), Array.isArray(e) && e.length > 4) throw new Error("padding arrays can only be 4 or less in length");
    var t,
        o,
        a,
        i,
        c = n(r);
    return "object" != typeof e || Array.isArray(e) ? (i = e, Array.isArray(i) && !i.every(function (e) {
      return J.has(e);
    }) && console.error("Invalid padding Type"), "padding: " + Array().concat(i).map(function (e) {
      return c[e];
    }).join(" ") + ";") : (t = e, o = Object.keys(t), a = Object.values(t), o.every(function (e) {
      return B.has(e);
    }) && a.every(function (e) {
      return J.has(e);
    }) || console.error("Invalid padding Type"), Object.entries(t).reduce(function (e, r) {
      var n = r[0],
          t = r[1];
      return B.has(n) ? e + "padding-" + function (e) {
        return "undefined" == typeof CSS || CSS.supports("padding-inline-start", "100px") ? {
          left: "inline-start",
          right: "inline-end",
          top: "block-start",
          bottom: "block-end",
          inlineStart: "inline-start",
          inlineEnd: "inline-end",
          blockStart: "block-start",
          blockEnd: "block-end"
        }[e] : {
          left: "left",
          right: "right",
          top: "top",
          bottom: "bottom",
          inlineStart: "left",
          inlineEnd: "right",
          blockStart: "top",
          blockEnd: "bottom"
        }[e];
      }(n) + ": " + c[t] + ";" : e;
    }, ""));
  })(e.padding);
  var r;
});
H.displayName = "PadBox";
var G = U.oneOf(Object.keys(r));
H.propTypes = {
  padding: U.oneOfType([G, U.objectOf(G), U.arrayOf(G)])
}, H.defaultProps = {
  padding: "lg"
};
export default H;